import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgReferral = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 64,
	height: 64,
	viewBox: "0 0 64 64",
	fill: "none",
	"aria-label": "referral source icon",
	style: { color: "#16A34A" },
	...props,
	children: [
		/* @__PURE__ */ _jsx("circle", {
			cx: 22,
			cy: 22,
			r: 7,
			fill: "none",
			stroke: "currentColor",
			strokeWidth: 4
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 42,
			cy: 22,
			r: 7,
			fill: "none",
			stroke: "currentColor",
			strokeWidth: 4
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M14 48c1-7 5-11 11-11s10 4 11 11M34 48c1-7 5-11 11-11 3 0 6 1 8 4",
			fill: "none",
			stroke: "currentColor",
			strokeWidth: 4,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M29 28h6",
			stroke: "currentColor",
			strokeWidth: 4,
			strokeLinecap: "round"
		})
	]
});
export default SvgReferral;
